// extracted by mini-css-extract-plugin
module.exports =  {"shortcut-container":"shortcut-container-iOrn9","label":"label-UWwT7"};